import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import JohnHomepage from "@/pages/JohnHomepage";
import ProfilePage from "@/pages/ProfilePage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import CartPage from "@/pages/CartPage";
import TradingGame from "@/pages/TradingGame";
import ArticlePage from "@/pages/ArticlePage";
import CategoryPage from "@/pages/CategoryPage";
import InvestorProof from "@/pages/InvestorProof";
import InvoicePage from "@/pages/InvoicePage";
import AdminInvoice from "@/pages/AdminInvoice";
import DemoBacktest from "@/pages/DemoBacktest";
import RefundResolution from "@/pages/RefundResolution";
import RegisterPage from "@/pages/RegisterPage";
import PropFirmResults from "@/pages/PropFirmResults";
import { CartProvider } from "@/context/CartContext";

function App() {
  return (
    <div className="App">
      <CartProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<JohnHomepage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/cart" element={<CartPage />} />
            <Route path="/game" element={<TradingGame />} />
            <Route path="/investor-proof" element={<InvestorProof />} />
            <Route path="/demo-backtest" element={<DemoBacktest />} />
            <Route path="/refund-resolution" element={<RefundResolution />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/prop-results" element={<PropFirmResults />} />
            <Route path="/invoice/:invoiceId" element={<InvoicePage />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/admin/invoice" element={<AdminInvoice />} />
            <Route path="/article/:id" element={<ArticlePage />} />
            <Route path="/category/:category" element={<CategoryPage />} />
          </Routes>
        </BrowserRouter>
      </CartProvider>
    </div>
  );
}

export default App;
